import { Bold, AlignLeft, AlignCenter, AlignRight } from "lucide-react";

const ALIGNS = [["left", AlignLeft, "Alinhar à esquerda"], ["center", AlignCenter, "Centralizar"], ["right", AlignRight, "Alinhar à direita"]];
const btn = "flex h-8 w-8 items-center justify-center rounded-sm border transition-colors";

export const TextFormatBar = ({ textareaRef, value, onChange, align, onAlign, testPrefix = "fmt" }) => {
  const bold = () => {
    const el = textareaRef.current;
    const s = el?.selectionStart ?? value.length;
    const e = el?.selectionEnd ?? value.length;
    const inner = value.slice(s, e) || "texto em negrito";
    onChange(`${value.slice(0, s)}**${inner}**${value.slice(e)}`);
    requestAnimationFrame(() => { el?.focus(); el?.setSelectionRange(s + 2, s + 2 + inner.length); });
  };
  return (
    <div className="mb-1 flex items-center gap-1" data-testid={`${testPrefix}-toolbar`}>
      <button type="button" onClick={bold} title="Negrito (selecione o texto)" className={`${btn} border-white/10 hover:border-white/30`} data-testid={`${testPrefix}-bold`}>
        <Bold className="h-4 w-4" />
      </button>
      {onAlign && <span className="mx-1 h-5 w-px bg-white/10" />}
      {onAlign && ALIGNS.map(([k, Icon, title]) => (
        <button key={k} type="button" onClick={() => onAlign(k)} title={title} data-testid={`${testPrefix}-align-${k}`}
          className={`${btn} ${align === k ? "border-[var(--brand)] bg-white/5 text-[var(--brand)]" : "border-white/10 hover:border-white/30"}`}>
          <Icon className="h-4 w-4" />
        </button>
      ))}
      <span className="ml-2 text-xs text-slate-500">Selecione um trecho e clique em B para negrito.</span>
    </div>
  );
};
